import PropTypes from 'prop-types'
import React from 'react'
import Input from '#components/a/form/Input'
import SearchGlass from '#components/svg/icons/SearchGlass'

function UserSearchField({handleInputChange, searchInput, placeholder}) {
  return (
    <div className="search userSearchField" data-testid="userSearchField">
      <SearchGlass />
      <Input
        name="userSearchInput"
        type="number"
        value={searchInput}
        className="search-input"
        placeholder={placeholder}
        onChangeHandle={evt => handleInputChange(evt.target.value)}
        onClick={evt => handleInputChange(evt.target.value)}
      />
    </div>
  )
}

UserSearchField.propTypes = {
  handleInputChange: PropTypes.func,
  searchInput: PropTypes.string,
  placeholder: PropTypes.string,
}

export default UserSearchField
